'use client';
import { ShopTireItem } from '../data/acessories';
import { ShopTireCard } from './ShopTireCard';

type ExploreAccessoriesProps = {
  items: ShopTireItem[];
  rideType?: string;
};

export default function ExploreAccessories({
  items,
  rideType = '',
}: ExploreAccessoriesProps) {
  return (
    <div className="bg-[#F6F6F6] py-32">
      <div className="flex w-full flex-col gap-y-32 sm:mx-auto sm:max-w-[150rem]">
        <div className="flex w-full justify-center">
          <h1 className="text-[3.7rem] font-bold capitalize text-black">
            Explore {rideType} Tire Accessories
          </h1>
        </div>

        <div className="flex w-full flex-col items-center gap-x-4 sm:flex-row">
          {items.map((item) => {
            return (
              <ShopTireCard
                key={item.name}
                image={item.image}
                name={item.name}
                description={item.description ?? ''}
                url={
                  item.url ?? `/search?keyword=${encodeURIComponent(item.name)}`
                }
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
